/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbs_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
    readonly " $refType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$data = PdpRespSidebarBlurbs_user;
export type PdpRespSidebarBlurbs_user$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'fc8f4160db78d54849d81f834bb5e596';
export default node;
